module.exports = __webpack_public_path__ + "assets/img/index-partner17.d980b5b7.jpg";